export const url = {
    base: 'https://api.agendaenlinea.cl/api',
    baseURL: 'https://api.agendaenlinea.cl/api',
    urlGlobal: 'https://globales.agendaenlinea.cl/',
}
export const env = {
    base: 'https://api.agendaenlinea.cl/api',
    baseURL: 'https://api.agendaenlinea.cl/api',
    urlGlobal: 'https://globales.agendaenlinea.cl/',
   
    DEVbase: 'https://api-amol.appmedic.cl/api',
    DEVbaseURL: 'https://api-amol.appmedic.cl/api',
    DEVurlGlobal: 'https://globales.agendaenlinea.cl/',

    LOCALbase: 'http://api-amol.local/api',
    LOCALbaseURL: 'http://api-amol.local/api',
    LOCALurlGlobal: 'https://globales.agendaenlinea.cl/',

    enviroment: 'production',

    URLEmail : 'https://tienda.agendaenlinea.cl/pendientes/email.php'
    //URLEmail : 'https://tienda.appmedic.cl/pendientes/email.php'
    //URLEmail : 'http://mantenimiento-amol.local/pendientes/email.php'
}



// WEBPACK FOOTER //
// ./src/config/env.js